import React from "react";

const Apply = () => {
  return (
    <main id="main">
      <section id="applications" className="applications-closed">
        <div className="container">
          <div className="applications-closed-content">
            <h1>Applications are currently closed</h1>
            <p>
              We do not have any open applications at this time. Please check
              back for future recruitment opportunities.
            </p>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Apply;
